export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
    const token = localStorage.getItem('userToken'); // Retrieve the token

    // Use a Record<string, string> for headers to allow dynamic key-value pairs
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...options.headers as Record<string, string>,
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    try {
        const response = await fetch(url, {
            ...options,
            headers,
        });


        // Handle 401 Unauthorized - Redirect to login page
        if (response.status === 401) {
            console.warn('Unauthorized access. Redirecting to login.');
            localStorage.removeItem('userToken'); // Clear the token
            window.location.href = '/login'; // Redirect to login page
            return;
        }

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('API request failed:', error);
        throw error;
    }
};


export const fetchWithAuthV2 = async (
  url: string,
  options: RequestInit = {}
) => {
  const tokenData = localStorage.getItem("userToken"); // KEEP AS STRING

  const response = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      "Content-Type": "application/json",
      Authorization: tokenData ? `Bearer ${tokenData}` : "",
    },
  });

  const contentType = response.headers.get("content-type");
  const isJson = contentType?.includes("application/json");
  const data = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      data?.message ||
      data?.error ||
      `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return data;
};
